import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-264ac21e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "download" }
const _hoisted_2 = { class: "logo flex justify-center scale-x-150" }
const _hoisted_3 = {
  key: 0,
  class: "underline",
  href: "itms-apps://itunes.apple.com/app/inksquad-artist/id1579690331"
}
const _hoisted_4 = {
  key: 1,
  class: "underline",
  href: "https://itunes.apple.com/app/inksquad-artist/id1579690331"
}
const _hoisted_5 = { class: "flex items-center justify-center" }
const _hoisted_6 = { class: "actions text-center" }
const _hoisted_7 = { class: "exclusive text-base text-white pb-1 bold-text" }
const _hoisted_8 = {
  key: 0,
  href: "itms-apps://itunes.apple.com/app/inksquad-artist/id1579690331",
  target: "_blank"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "px-8 py-3 standard-button-blue rounded-full uppercase button-text mx-auto mb-1" }, "Download", -1))
const _hoisted_10 = { class: "exclusive text-xs text-gray-200" }
const _hoisted_11 = {
  key: 1,
  href: "https://itunes.apple.com/app/inksquad-artist/id1579690331",
  target: "_blank"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "px-8 py-3 standard-button-blue rounded-full uppercase button-text mx-auto mb-1" }, "Download", -1))
const _hoisted_13 = { class: "exclusive text-xs text-gray-200" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InkLogo = _resolveComponent("InkLogo")!
  const _component_TitleTemplate = _resolveComponent("TitleTemplate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TitleTemplate, null, {
      grey: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_InkLogo)
        ])
      ]),
      main: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.homepage.downloadsection.title')), 1)
      ]),
      text: _withCtx(() => [
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('components.homepage.downloadsection.price')) + " ", 1),
          (_ctx.operatingSystem.os === 'Mac OS')
            ? (_openBlock(), _createElementBlock("a", _hoisted_3, _toDisplayString(_ctx.$t('components.homepage.downloadsection.store')) + ".", 1))
            : (_openBlock(), _createElementBlock("a", _hoisted_4, _toDisplayString(_ctx.$t('components.homepage.downloadsection.store')), 1))
        ])
      ]),
      button: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('components.general.availability')), 1),
            (_ctx.operatingSystem.os === 'Mac OS')
              ? (_openBlock(), _createElementBlock("a", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('components.general.availability-2')), 1)
                ]))
              : (_openBlock(), _createElementBlock("a", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('components.general.availability-2')), 1)
                ]))
          ])
        ])
      ]),
      _: 1
    })
  ]))
}